import { axios } from '../../services/axios';

export default async function createApprovalCode(params) {
    return axios
        .post('/ApprovalCode', params)
        .then((res) => res)
        .catch((e) => e);
}
